import type { CreateOneShopReturnToStoreStoreDto } from "../generated/schema";
import { useApiMutation } from "./use-api-mutation";
import useInvalidateShop from "./use-invalidate-shop";

type UseCreateShopStoreParams = {
	shopId: string;
	onSettled?: (
		data: unknown,
		error: unknown,
	) => Promise<unknown> | unknown;
};

export default function useCreateShopStore({
	onSettled,
	shopId,
}: UseCreateShopStoreParams) {
	return useApiMutation("post", "/shops/{shopId}/return-to-store/stores", {
		invalidate: useInvalidateShop(shopId),
		onSettled,
		mapVariables: (requestBody: CreateOneShopReturnToStoreStoreDto) => ({
			params: { path: { shopId } },
			body: requestBody,
		}),
	});
}
